module.exports = __webpack_public_path__ + "img/dehsen.50169fba.jpg";